module.exports = __webpack_public_path__ + "assets/cfangqi.c602a550fa4de9ef88fff0745e2740ac.png";